/*
 * 把 public/ 下的绝对路径接上部署前缀。
 *
 * 背景：这个包挂在 `lab.miyang.cn/ripple`（2026-09-10 用户裁决），
 *   于是 Vite 的 `base` 是 `/ripple/`。base 只管**构建产物**（JS、CSS、被 import 的图），
 *   它不会去改代码里写死的字符串——`/img/milli-coin.png`、`/cases/k_after.jpg`
 *   这些是运行时才拼进 `src` 的，Vite 看不见，于是会照原样请求到站点根，
 *   而站点根是米羊 Lab，不是这个工具。结果是一堆 404，而且**只在线上出现**。
 * 设计意图：所有这类路径过一遍这个函数。它读 `import.meta.env.BASE_URL`
 *   （dev 时是 `/ripple/`，构建时也是 `/ripple/`，改 base 两边一起变），
 *   于是「前缀」这件事只有一处知识，不散落在十几个 `src=` 里。
 * 关键约束：
 *   1. 只接 public 下的路径。用户自己那张图是 `URL.createObjectURL` 出来的
 *      blob 地址，不能接前缀（`asset` 只认以 `/` 开头的相对路径，blob: 会原样返回）。
 *   2. 数据文件（`mock/cases.ts` 由脚本生成）里仍然写不带前缀的绝对路径。
 *      那些路径描述的是「文件在 public 里的位置」，与部署到哪个前缀无关；
 *      把前缀写进生成的数据，等于让数据文件跟着部署路径变。
 */
export function asset(path: string): string {
  if (!path.startsWith('/')) return path
  const base = import.meta.env.BASE_URL.replace(/\/$/, '')
  // 已经带着前缀的原样放过：前后对比板（CaseCompare）现在也给用户自己那张作业的图
  // 用，而那些地址是 `/ripple/api/jobs/…`（jobClient 拼的，已含前缀）。
  // 不认这一条就会拼成 `/ripple/ripple/api/…`，线上 404、本地也 404。
  if (base && (path === base || path.startsWith(base + '/'))) return path
  return base + path
}
